import React from "react";
import T from "../TheTool";

function GUI_Input3TextAreas(props) {
	const handleTextChange = (event) => {
		props.area1Change(event.target.value);
	};

	const handleTextChange2 = (event) => {
		props.area2Change(event.target.value);
	};

	function Area3() {
		var label1 = T.getValue(props.label, "");
		var text1 = T.getValue(props.text1, "");
		var label2 = T.getValue(props.label2, "");
		var text2 = T.getValue(props.text2, "");
		var label3 = T.getValue(props.label3, "");
		var text3 = T.getValue(props.text3, "");
		return (
			<div
				style={{
					// width: "auto",
					// alignSelf: "center",
					// alignItems: "center",
					// alignContent: "center",
					// marginLeft: "auto",
					// marginRight: "auto",
					// borderCollapse: "collapse",
					// margin: "auto",
				}}
			>
				<table
					style={{
						// width: "auto",
						// alignSelf: "center",
						// alignItems: "center",
						// alignContent: "center",
						// marginLeft: "auto",
						// marginRight: "auto",
						// borderCollapse: "collapse",
						margin: "auto",
					}}
				>
					<tr>
						<th style={{ fontSize: 20 }}>{label1}</th>
						<th style={{ fontSize: 20 }}>{label2}</th>
						<th style={{ fontSize: 20 }}>{label3}</th>
					</tr>
					<tr>
						<td>
							<textarea
								style={{
									minHeight: "308px",
									// minWidth: "100%",
									whiteSpace: "pre-line",
									// paddingLeft:  "38px",
									// marginLeft: "1%",
									marginRight: "1%",
									fontSize: 16,
									width: 150,
								}}
								value={text1}
								onChange={handleTextChange}
							></textarea>
						</td>
						<td>
							<textarea
								style={{
									minHeight: "308px",
									// minWidth: "100%",
									whiteSpace: "pre-line",
									marginLeft: "1%",
									// marginRight: "1%",
									fontSize: 16,
									width: 150,
								}}
								value={text2}
								onChange={handleTextChange2}
							></textarea>
						</td>
						<td>
							<textarea
								style={{
									minHeight: "308px",
									// minWidth: "100%",
									whiteSpace: "pre-line",
									marginLeft: "1%",
									// marginRight: "1%",
									fontSize: 16,
									width: 150,
								}}
								value={text3}
								onChange={handleTextChange2}
							></textarea>
						</td>
					</tr>
				</table>
			</div>
		);
	}

	return (
		<div>
			{Area3()}
		</div>
	);
}

export default GUI_Input3TextAreas;
